export const COMPLIANCE_DOCUMENT_COVERAGES_TABLE_NAME = 'complianceDocumentCoverages';

// Document table constants

// The columns available to be shown in a documents table.
export const COMPLIANCE_DOCUMENT_COVERAGES_TABLE_COLUMNS = {
  start_date: { label: 'Coverage Start', key: 'start_date' },
  end_date: { label: 'Coverage End', key: 'end_date' },
  verified: { label: 'Verification', key: 'verified' },
  actions: { label: 'Verification History', key: 'actions' },
};

export const COMPLIANCE_DOCUMENT_COVERAGES_TABLE_DEFAULT_COLUMNS = [
  COMPLIANCE_DOCUMENT_COVERAGES_TABLE_COLUMNS.start_date,
  COMPLIANCE_DOCUMENT_COVERAGES_TABLE_COLUMNS.end_date,
  COMPLIANCE_DOCUMENT_COVERAGES_TABLE_COLUMNS.verified,
  COMPLIANCE_DOCUMENT_COVERAGES_TABLE_COLUMNS.actions,
];
